import { render, staticRenderFns } from "./PrivilegesDialog.vue?vue&type=template&id=0416dfc6"
import script from "./PrivilegesDialog.vue?vue&type=script&lang=js"
export * from "./PrivilegesDialog.vue?vue&type=script&lang=js"
import style0 from "./PrivilegesDialog.vue?vue&type=style&index=0&id=0416dfc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports